<template>

    <v-page>

        <transition name="modal">
            <v-modal-event-segment v-if="showModal === 'segment'" :event="event" @created="viewSegment($event)" />
        </transition>

        <v-page-header icon="fas fa-fire">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'events' }">Events</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="event">{{ event.name }}</v-breadcrumb-item>
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-searchbar :model="params.q" @input="params.q = $event" :action="getCustomers" />
            <v-button size="sm" @click.native="$store.commit('showModal', 'segment')">Create Segment</v-button>
        </v-page-filters>

        <v-page-body>

            <v-notice v-if="!customers.length" title="No Performers" message="There are no customers who performed this event." />

            <v-page-section v-else padded>
                <template #title>
                    <span>{{ pagination | paginationTitle('Performers (', ')') }}</span>
                </template>
                <template #body>
                    <v-table scrollable>
                        <thead>
                            <th></th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>First Performed</th>
                            <th>Last Performed</th>
                            <th>Count</th>
                        </thead>
                        <tbody>
                            <tr v-for="c in customers" :key="c.id" @click="viewCustomer(c.id)">
                                <td class="w-34 pr-0">
                                    <v-avatar
                                        :name="c.initials"
                                        :color="c.color"
                                        :url="c.gravatar ? c.gravatar + '&s=80' : ''"
                                        :size="34"
                                        :radius="17">
                                    </v-avatar>
                                </td>
                                <td>{{ c.name | truncate(30) }}</td>
                                <td><a :href="'mailto:' + c.email">{{ c.email | truncate(30) }}</a></td>
                                <td>{{ c.summary.first_request_at | dateTime }}</td>
                                <td>{{ c.summary.last_request_at | dateTime }}</td>
                                <td>{{ c.summary.count | numeral('0,0') }}</td>
                            </tr>
                        </tbody>
                    </v-table>
                </template>
                <template #footer>
                    <v-pagination :count="pagination.last_page" @search="getCustomers($event)" />
                </template>
            </v-page-section>
        </v-page-body>

    </v-page>

</template>

<script>

import EventApi from '@api/EventApi';
import ModalEventSegment from '@modals/event/ModalEventSegment';

export default {

    components: {
        'v-modal-event-segment': ModalEventSegment,
    },

    data() {
        return {
            event: null,
            customers: [],
            pagination: {},
            params: {
                sort: 'last_request_at',
            },
        }
    },

    mounted() {
        this.reload();
    },

    methods: {

        reload() {
            this.$store.commit('loading', true);
            EventApi.getEvent(this.$route.params.id)
                .then((response) => {
                    this.event = response.data.data;
                    this.getCustomers();
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        getCustomers(page = 1) {
            window.scrollTo(0, 0);
            this.$store.commit('loading', true);
            this.params.page = page;
            EventApi.getCustomers(this.event.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.customers = response.data.data;
                    this.pagination = response.data.pagination;
                    this.$events.$emit('pageLoaded');
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

        viewCustomer(id) {
            this.$router.push({
                name: 'customer',
                params: { id: id },
            });
        },

        viewSegment(id) {
            this.$router.push({
                name: 'segments-edit',
                params: { id: id },
            });
        },

    },

}

</script>
